const baseUrl = `/client/customization-org`;

export const CREATE = `${baseUrl}/`;
export const GET = `${baseUrl}/`;
export const UPDATE = `${baseUrl}/`;